
import React from 'react';
import './Footer.css';
import {
  FaTiktok,
  FaInstagram,
  FaLinkedin,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaWhatsapp
} from 'react-icons/fa';

function Footer() {
  return (
    <footer className="footer">
      {}
      <div className="footer-top">
        <div className="footer-social">
          <span className="stay-connected">Stay Connected</span>
          <div className="social-icons">
            <a href="https://www.tiktok.com/@studio13.sa?_r=1&_t=ZS-95LB16RD0z2" className="tiktok" aria-label="TikTok" target="_blank" rel="noopener noreferrer">
              <FaTiktok />
            </a>
            <a href="https://www.instagram.com/studio13.sa?igsh=eXQzbXJ3cHk0emZz" className="instagram" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </a>
            <a href="https://www.linkedin.com/company/luca-miro/" className="linkedin" aria-label="LinkedIn">
              <FaLinkedin />
            </a>
            <a href="https://wa.me/966543330505" className="whatsapp" aria-label="WhatsApp">
              <FaWhatsapp />
            </a>
          </div>
        </div>
        <div className="footer-links">
          {/* <a href="/privacy" className="footer-link">Privacy Policy</a>
          <a href="/terms"   className="footer-link">Terms &amp; Conditions</a> */}
        </div>
      </div>

      {}
      <div className="footer-bottom">
        <div className="contact-info">
          <a href="mailto:Info@lucamiro.me">
            <FaEnvelope /> Info@lucamiro.me
          </a>
          <a href="tel:+966543330505">
            <FaPhone /> +966543330505
          </a>
          <span>
            <FaMapMarkerAlt /> Jeddah, Saudi Arabia
          </span>
        </div>
        <div className="copyright">
          © 2025 Studio13. All rights reserved.
        </div>
      </div>
    </footer>
  );
}

export default Footer;